import { z } from 'zod'

import { mapItem } from '../utils'

export const supportTypeMap: Record<SupportType, mapItem> = {
  feature_request: { label: 'Feature Request' },
  account_issues: { label: 'Account Issues' },
  referral_issues: { label: 'Referral Issues' },
  general_feedback: { label: 'General Feedback' },
  technical_support: { label: 'Technical Support' },
  other_inquiries: { label: 'Other Inquiries' },
}

export const supportTicketResponseSchema = z.object({
  ticket_id: z.string(),
  status: z.string(),
  message: z.string(),
})

export type SupportType =
  | 'feature_request'
  | 'account_issues'
  | 'referral_issues'
  | 'general_feedback'
  | 'technical_support'
  | 'other_inquiries'
export const supportTypeSchema = z.enum(Object.keys(supportTypeMap) as [SupportType, ...SupportType[]])

export const supportTicketCreateSchema = z.object({
  type: supportTypeSchema,
  description: z
    .string()
    .min(10, 'Message must be at least 10 characters')
    .max(1000, 'Message cannot exceed 1000 characters'),
})

export type SupportTicketCreate = z.infer<typeof supportTicketCreateSchema>
export type SupportTicketResponse = z.infer<typeof supportTicketResponseSchema>
